import { PageHero } from "@/components/site/PageHero";
import { Support } from "@/components/home/SolaSections";
import { CTA } from "@/components/site/CTA";
import { BookCall } from "@/components/site/BookCall";

export default function SupportIndex() {
  return (
    <div data-testid="support-index-page">
      <PageHero eyebrow="Support" lines={["Real people.", "Real support."]}
        sub="Customer service, tech support, a dedicated account manager and equipment help. Pick a team to see how they help your business."
        img="/img/support-agent.jpg" />
      <Support />
      <BookCall />
      <CTA />
    </div>
  );
}
